<template>
  <div
    class="d-flex align-items-center tag"
    :style="tagColor"
    @click.stop="$emit('delete', tag)"
  >
    <img v-if="tag.iconUrl" :src="tag.iconUrl" class="tag-icon" />
    <font-awesome-icon
      :icon="tag.icon"
      class="tag-icon"
      :style="iconColor"
      v-else-if="tag.icon"
    /><span :class="{ 'ml-2': (tag.label && tag.icon) || tag.iconUrl }">{{
      computedLabel
    }}</span>
    <font-awesome-icon
      v-if="showClose"
      :icon="['fal', 'times']"
      class="icon-close"
    />
  </div>
</template>

<script>
export default {
  name: 'tag-input',
  props: {
    tag: {
      type: Object,
      default: () => {
        return {
          id: null,
          value: 'content',
          type: 'type',
          label: 'knowledge.search-admin.content',
          icon: ['fad', 'barcode-scan'],
          needTrad: true,
        };
      },
    },
    showClose: {
      type: Boolean,
      default: true,
    },
  },
  computed: {
    tagColor() {
      return {
        border: `0.5px solid ${this.tag.color ? this.tag.color : '#ADB5BD'}`,
        background: `${this.tag.color}1A`,
      };
    },
    iconColor() {
      return {
        color: this.tag.color,
      };
    },
    computedLabel() {
      return this.tag.needTrad ? this.$t(this.tag.label) : this.tag.label;
    },
  },
};
</script>

<style lang="scss" scoped>
.tag {
  font-size: 14px;
  padding: 5px 8px;
  line-height: 0.93;
  color: $grey-8-mayday;
  background: $grey-1-mayday;
  border-radius: 2px;
  cursor: pointer;
}

.tag-icon {
  font-size: 13px;
  width: 13px;
  height: 13px;
}

.icon-close {
  margin-left: 8px;
  font-size: 12px;
  color: $grey-6-mayday;
}
</style>
